import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const FileCopySVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default FileCopySVG;
